export default __webpack_public_path__ + "static/media/tooltip.48e70efb.svg";